import { generatePath } from 'react-router-dom'
import isAllowed from 'src/utils/isAllowed'

class RouteError extends Error {
    constructor(msg) {
        super('RouteError: ' + msg)
    }
}

export const routeConfig = [
    {
        path: '/logout',
        title: 'Logout',
        component: './Logout',
        name: 'logout',
        breadcrumbs: [{ label: 'Logout' }],
    },
    {
        path: '/solutions/:view/:nodeId',
        title: 'Solutions',
        component: './Solutions',
        name: 'solutions-focus',
        permissions: context => isAllowed(context),
        breadcrumbs: params => [
            { label: 'Solutions', linkName: 'solutions' },
            { label: `Solution: ${params.nodeId}` },
        ],
    },
    {
        path: '/solutions/:view(list|graph)',
        title: 'Solutions',
        component: './Solutions',
        name: 'solutions',
        breadcrumbs: [{ label: 'Solutions' }],
        permissions: context => isAllowed(context),
    },
    {
        path: '/unauthorized',
        title: 'Unauthorized',
        component: './Unauthorized',
        name: 'unauthorized',
        breadcrumbs: [{ label: 'Unauthorized' }],
    },
    {
        path: '/',
        title: 'Homepage',
        component: './Homepage',
        name: 'homepage',
        breadcrumbs: [{ label: 'Dashboard' }],
    },
]

export const reverse = (name, params = {}, queryParams = {}) => {
    const routes = routeConfig.filter(route => route.name === name)
    if (routes.length === 0) {
        throw new RouteError(`No matches found in routeConfig for ${name}`)
    } else if (routes.length > 1) {
        throw new RouteError(
            `Multiple matches found in routeConfig for ${name}: ${routes
                .map(r => r.path)
                .join(', ')}`
        )
    }
    // this will raise a TypeError if params provided do not match the path
    const path = generatePath(routes[0].path, params)
    if (Object.entries(queryParams).length) {
        const searchParams = new URLSearchParams(queryParams)

        return `${path}?${searchParams.toString()}`
    }
    return path
}
